import { RefObject, createRef, useEffect } from "react";

let firstClientX: number, clientX: number;

const preventTouch = (e: TouchEvent): false | undefined => {
  const minValue = 5; // threshold

  clientX = e.touches[0].clientX - firstClientX;

  // Vertical scrolling does not work when you start swiping horizontally.
  if (Math.abs(clientX) > minValue) {
    e.preventDefault();

    return false;
  }
};

const touchStart = (e: TouchEvent): void => {
  firstClientX = e.touches[0].clientX;
};

const useSliderScrollBlock = (): { containerRef: RefObject<any> } => {
  const containerRef = createRef<any>();

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.addEventListener("touchstart", touchStart);
      containerRef.current.addEventListener("touchmove", preventTouch, {
        passive: false,
      });
    }

    return () => {
      if (containerRef.current) {
        containerRef.current.removeEventListener("touchstart", touchStart);
        containerRef.current.removeEventListener("touchmove", preventTouch, {
          passive: false,
        });
      }
    };
  });

  return { containerRef };
};

export default useSliderScrollBlock;
